export const BASKET_LOAD = 'basket:load';
export const BASKET_DELETE_PRODUCTS = 'basket:delete_products';
export const BASKET_SET_PRODUCT = 'basket:set_product';
export const BASKET_UPDATE = 'basket:update';
